module.exports = __webpack_public_path__ + "static/img/1-1.b9205d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-1.jpg
// module id = rKIu
// module chunks = 1